import { HowlerSoundFile } from "source/app/services/Sound/HowlerSoundFile";

const shoutSounds = {
    grunt: new HowlerSoundFile("grunt"),
    shoutAuraWhisper: new HowlerSoundFile(`Shout_Aurawhisper`),
    shoutBendWill: new HowlerSoundFile(`Shout_BendWill`),
    shoutCallDragon: new HowlerSoundFile(`Shout_Calldragon`),
    shoutCallOfValor: new HowlerSoundFile(`Shout_CallOfValor`),
    shoutDisarm: new HowlerSoundFile(`Shout_Disarm`),
    shoutDismay: new HowlerSoundFile(`Shout_Dismay`),
    shoutDragonAspect: new HowlerSoundFile(`Shout_DragonAspect`),
    shoutMarkedForDeath: new HowlerSoundFile(`Shout_Markedfordeath`),
    shoutThrowVoice: new HowlerSoundFile(`Shout_ThrowVoice`),
    shoutUnrelentingForce: new HowlerSoundFile(`Shout_UnrelentingForce`),
    shoutWhirlwindsprint: new HowlerSoundFile(`Shout_Whirlwindsprint`),
    shoutWhoo: new HowlerSoundFile("shout_Whoo"),
    shoutYeah: new HowlerSoundFile("Shout_Yeah"),
};

const marchingSounds = {
    marching1: new HowlerSoundFile("marching-1"),
    marching2: new HowlerSoundFile("marching-2"),
    marching3: new HowlerSoundFile("marching-3"),
    marching4: new HowlerSoundFile("marching-4"),
};

const longerMusicalSounds = {
    brothersChant: new HowlerSoundFile("brothers-chant"),
    brothersChantLong: new HowlerSoundFile("brothers-chant-long"),
    curiousTrumpet: new HowlerSoundFile("curious-trumpet"),
    fanfareTrumpets: new HowlerSoundFile("fanfare-trumpets"),
    feverStrings: new HowlerSoundFile("fever-strings"),
    taikoLoading: new HowlerSoundFile("taikoLoading"),
    tfa_accomplishment: new HowlerSoundFile("tfa-accomplishment"),
    trumpetFanfare: new HowlerSoundFile("trumpetFanfare"),
};

const shortSounds = {
    ambientHalo: new HowlerSoundFile("short-sounds/ambient_halo"),
    bell_table: new HowlerSoundFile("short-sounds/bell_table"),
    bellDingDong: new HowlerSoundFile("short-sounds/bell_ding_dong"),
    bellLong: new HowlerSoundFile("short-sounds/bell_long"),
    chimes_quiet: new HowlerSoundFile("short-sounds/chimes_quiet"),
    chimes_varied_long: new HowlerSoundFile("short-sounds/chimes_varied_long"),
    chimes_varied_short: new HowlerSoundFile(
        "short-sounds/chimes_varied_short"
    ),
    clangSpacey: new HowlerSoundFile("short-sounds/clang_spacey"),
    electronic_tone_low_soft: new HowlerSoundFile(
        "short-sounds/electronic_tone_low_soft"
    ),
    electronic_tones_melodic_positive: new HowlerSoundFile(
        "short-sounds/electronic_tones_melodic_positive"
    ),
    electronic_tones_melodic_positive2: new HowlerSoundFile(
        "short-sounds/electronic_tones_melodic_positive2"
    ),
    electronic_tones_melodic_soft: new HowlerSoundFile(
        "short-sounds/electronic_tones_melodic_soft"
    ),
    electronic_tones_melodic_soft2: new HowlerSoundFile(
        "short-sounds/electronic_tones_melodic_soft2"
    ),
    electronic_tone_soft: new HowlerSoundFile(
        "short-sounds/electronic_tone_soft"
    ),
    harp_pluck_C4: new HowlerSoundFile("short-sounds/harp_pluck_C4"),
    harp_pluck_C5: new HowlerSoundFile("short-sounds/harp_pluck_C5"),
    harp_pluck_C6: new HowlerSoundFile("short-sounds/harp_pluck_C6"),
    harp_pluck_C7: new HowlerSoundFile("short-sounds/harp_pluck_C7"),
    kickdrum_heavy: new HowlerSoundFile("short-sounds/kickdrum_heavy"),
    metal_clang_short_2: new HowlerSoundFile(
        "short-sounds/metal_clang_short_2"
    ),
    metal_clang_short: new HowlerSoundFile("short-sounds/metal_clang_short"),
    metal_keys_jangling_1: new HowlerSoundFile(
        "short-sounds/metal_keys_jangling_1"
    ),
    metal_keys_jangling_2: new HowlerSoundFile(
        "short-sounds/metal_keys_jangling_2"
    ),
    metal_keys_jangling_3: new HowlerSoundFile(
        "short-sounds/metal_keys_jangling_3"
    ),
    metal_keys_jangling_4: new HowlerSoundFile(
        "short-sounds/metal_keys_jangling_4"
    ),
    metal_swipe: new HowlerSoundFile("short-sounds/metal_swipe"),
    metalBlunt: new HowlerSoundFile("short-sounds/metal_blunt"),
    metallicClosing: new HowlerSoundFile("short-sounds/metallic_closing"),
    metallicOpening: new HowlerSoundFile("short-sounds/metallic_opening"),
    metallicSliding: new HowlerSoundFile("short-sounds/metallic_sliding"),
    metalRing: new HowlerSoundFile("short-sounds/metal_ring"),
    paper_long_flip: new HowlerSoundFile("short-sounds/paper_long_flip"),
    paper_quick_flip: new HowlerSoundFile("short-sounds/paper_quick_flip"),
    paper_sliding: new HowlerSoundFile("short-sounds/paper_sliding"),
    snapsMultiple: new HowlerSoundFile("short-sounds/snaps_multiple"),
    switch_toggle: new HowlerSoundFile("short-sounds/switch_toggle"),
    switchbulb_loud: new HowlerSoundFile("short-sounds/switchbulb_loud"),
    switchbulb_soft: new HowlerSoundFile("short-sounds/switchbulb_soft"),
    ticking_timer: new HowlerSoundFile("short-sounds/ticking_timer"),
    voice_monks_chant1: new HowlerSoundFile("short-sounds/voice_monks_chant1"),
    voice_monks_chant2: new HowlerSoundFile("short-sounds/voice_monks_chant2"),
    voice_monks_chant3: new HowlerSoundFile("short-sounds/voice_monks_chant3"),
    wooden_creak: new HowlerSoundFile("short-sounds/wooden_creak"),
    wooden_tap: new HowlerSoundFile("short-sounds/wooden_tap"),
    wooden_thump: new HowlerSoundFile("short-sounds/wooden_thump"),
};

export const Sounds = {
    ...shortSounds,
    ...shoutSounds,
    ...longerMusicalSounds,
    ...marchingSounds,
};
